import {
  AboutUs,
  Team,
} from "../components/common/page-components";

const About = () => {
  return (
    <div className="pt-20 px-[3%] md:px-[6%]">
      <AboutUs />
      <Team />
    </div>
  );
};

export default About;
